import { createRouter } from '@tanstack/react-router'
import { useEffect } from 'react'

// Import the generated route tree
import { routeTree } from './routeTree.gen'

function DefaultErrorComponent({ error }: { error: unknown }) {
  useEffect(() => {
    // Always log full error details to console for production debugging.
    // (The built-in error UI can be too minimal / minified.)
    // eslint-disable-next-line no-console
    console.error('[PulseDigital Router Error]', { build: __BV_BUILD_ID__, error })
  }, [error])

  const message =
    error instanceof Error
      ? error.message
      : typeof error === 'string'
        ? error
        : error
          ? JSON.stringify(error)
          : 'Unknown error'

  const stack = error instanceof Error ? error.stack : undefined

  return (
    <div className="min-h-[60vh] px-4 py-10">
      <div className="mx-auto w-full max-w-3xl rounded-2xl border border-white/10 bg-black/30 p-6">
        <p className="m-0 text-xs font-extrabold uppercase tracking-[0.18em] text-[#5a6d8a]">Something went wrong</p>
        <h1 className="m-0 mt-2 text-xl font-extrabold tracking-tight text-[#f0f6ff]">App error</h1>
        <p className="m-0 mt-2 text-[11px] text-[#5a6d8a]">
          Build: <span className="font-mono text-[#7a92b8]">{__BV_BUILD_ID__}</span>
        </p>
        <p className="m-0 mt-3 text-sm text-[#8ecfff] break-words">{message}</p>
        {stack ? (
          <pre className="mt-4 max-h-[40vh] overflow-auto rounded-xl border border-white/10 bg-black/40 p-4 text-xs text-[#7a92b8]">
            {stack}
          </pre>
        ) : null}
        <p className="m-0 mt-4 text-xs text-[#5a6d8a]">
          Tip: open DevTools Console to see the full logged error.
        </p>
      </div>
    </div>
  )
}

// Create a new router instance
export const getRouter = () => {
  const router = createRouter({
    routeTree,
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
    defaultErrorComponent: DefaultErrorComponent,
  })

  return router
}
